export const phoneNumberCheckerLayout = {
  title: 'Узнайте, кто одобрит займ*',
  privacyAgreement: 'Вводя номер телефона и нажимая кнопку “Показать”, вы подтверждаете ознакомление и соглашаетесь с',
  termsLink: 'Согласием на обработку персональных данных',
};
